module.exports = __webpack_public_path__ + "media/images/map-icons/stop_icon@2x-b02d11528477bb1260970852ef7eeee9.png";